import React, { useState, useEffect } from 'react';
import '../../styles/AdvancedSearchPopup.css';

const AdvancedSearchPopup = ({ 
  isOpen, 
  onClose, 
  onApplyFilters, 
  currentFilters,
  filterOptions 
}) => {
  const [localFilters, setLocalFilters] = useState({
    branch: '',
    courseType: '',
    courseName: '',
    enrollment_status: '',
    source: '',
    ...currentFilters
  });

  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);

  const enrollment_statusOptions = [
    'Select Enrollment Status',
    'Hot',
    'Warm',
    'Postive',
    'Cold',
    'Ringing',
    'Joined',
    'Scrab',
    'Not interested',
    'Un touched',
    'Switch off',
    'Will update',
    'Call rejected',
    'Not reachable'
  ];

  const sourceOptions = [
    { value: 'Meta', label: 'Meta' },
    { value: 'Website Call', label: 'Website Call' },
    { value: 'Web Form', label: 'Web Form' },
    { value: 'Student Reference', label: 'Student Reference' },
    { value: 'Direct WalkIn', label: 'Direct WalkIn' },
    { value: 'Direct Call', label: 'Direct Call' },
    { value: 'Sulekha', label: 'Sulekha' },
    { value: 'Website Msg', label: 'Website Msg' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Youtube', label: 'Youtube' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Google WhatsAPP', label: 'Google WhatsAPP' },
    { value: 'Google AD', label: 'Google AD' },
    { value: 'APNA', label: 'APNA' },
    { value: 'Naukri', label: 'Naukri' },
    { value: 'INDEED', label: 'INDEED' },
    { value: 'HR Job Portal', label: 'HR Job Portal' },
    { value: 'IndiaMART', label: 'IndiaMART' },
    { value: 'Just Dial', label: 'Just Dial' },
    { value: 'MD Reference', label: 'MD Reference' },
    { value: 'Other Reference', label: 'Other Reference' },
  ];

  // Fetch courses from API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/course`);
        const coursesData = await response.json();
        setCourses(coursesData);
        setFilteredCourses(coursesData);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    if (isOpen) {
      fetchCourses();
    }
  }, [isOpen]);

  // Filter courses based on selected course type
  useEffect(() => {
    if (localFilters.courseType) {
      const filtered = courses.filter(course => course.courseType === localFilters.courseType);
      setFilteredCourses(filtered);
      // Reset course name if it doesn't match the new course type
      if (localFilters.courseName) {
        const courseExists = filtered.some(course => course.courseName === localFilters.courseName);
        if (!courseExists) {
          setLocalFilters(prev => ({ ...prev, courseName: '' }));
        }
      }
    } else {
      setFilteredCourses(courses);
    }
  }, [localFilters.courseType, courses]);

  // Update local filters when currentFilters prop changes
  useEffect(() => {
    setLocalFilters({
      branch: '',
      courseType: '',
      courseName: '',
      enrollment_status: '',
      source: '',
      ...currentFilters
    });
  }, [currentFilters]);

  const handleFilterChange = (filterType, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const handleApply = () => {
    onApplyFilters(localFilters);
    onClose();
  };

  const handleClear = () => {
    const clearedFilters = {
      branch: '',
      courseType: '',
      courseName: '',
      enrollment_status: '',
      source: ''
    };
    setLocalFilters(clearedFilters);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('advanced-search-overlay')) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="advanced-search-overlay" onClick={handleOverlayClick}>
      <div className="advanced-search-popup">
        <div className="advanced-search-header">
          <h2>Advanced Search</h2>
          <button className="closewd-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="advanced-search-content">
          <div className="filter-row">
            <div className="filter-group">
              <label htmlFor="branch-select">Branch</label>
              <select
                id="branch-select"
                className="advanced-filter-dropdown"
                value={localFilters.branch}
                onChange={(e) => handleFilterChange('branch', e.target.value)}
              >
                <option value="">All Branches</option>
                {filterOptions.branches.map((branch, index) => (
                  <option key={index} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label htmlFor="course-type-select">Course Type</label>
              <select
                id="course-type-select"
                className="advanced-filter-dropdown"
                value={localFilters.courseType}
                onChange={(e) => handleFilterChange('courseType', e.target.value)}
              >
                <option value="">All Course Types</option>
                {filterOptions.courseTypes.map((courseType, index) => (
                  <option key={index} value={courseType}>
                    {courseType}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="filter-row">
            <div className="filter-group">
              <label htmlFor="course-name-select">Course Name</label>
              <select
                id="course-name-select"
                className="advanced-filter-dropdown"
                value={localFilters.courseName}
                onChange={(e) => handleFilterChange('courseName', e.target.value)}
                disabled={!localFilters.courseType}
              >
                <option value="">All Course Names</option>
                {filteredCourses.map((course) => (
                  <option key={course.id} value={course.courseName}>
                    {course.courseName}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label htmlFor="enrollment-status-select">Enrollment Status</label>
              <select
                id="enrollment-status-select"
                className="advanced-filter-dropdown"
                value={localFilters.enrollment_status}
                onChange={(e) => handleFilterChange('enrollment_status', e.target.value)}
              >
                <option value="">All Status</option>
                {enrollment_statusOptions.slice(1).map((status, index) => (
                  <option key={index} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="filter-row">
            <div className="filter-group">
              <label htmlFor="source-select">Source</label>
              <select
                id="source-select"
                className="advanced-filter-dropdown"
                value={localFilters.source}
                onChange={(e) => handleFilterChange('source', e.target.value)}
              >
                <option value="">All Sources</option>
                {sourceOptions.map((source, index) => (
                  <option key={index} value={source.value}>
                    {source.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="advanced-search-footer">
          <button className="clearwd-btn" onClick={handleClear}>
            Clear All
          </button>
          <div className="actionwd-buttons">
            <button className="cancelwd-btn" onClick={onClose}>
              Cancel
            </button>
            <button className="applywd-btn" onClick={handleApply}>
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSearchPopup;